export default __webpack_public_path__ + "static/background-38468dd6f51a8cf8941546effe4a65f1.jpg";